import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dropdown} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';
import createUUID from '../util/createUUID';
import {faEllipsisH} from '@fortawesome/free-solid-svg-icons/faEllipsisH'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


const LinksSecondaryDropdown = (props) => {
    const {t} = useTranslation();

    const links = [
        {
            children: t(`Links.provider-acceptance-terms`),
            to: '/provider-acceptance-terms'
        },
        {
            children: t(`Links.privacy-policy`),
            to: '/privacy-policy'
        },
        {
            children: t(`Links.contact-us`),
            to: '/contact-us'
        },
        {
            children: t(`Links.sitemap`),
            to: '/sitemap'
        },
    ]

    const linksFragment = [];

    for (const link of links) {
        linksFragment.push((
            <LinkContainer
                key={createUUID()}
                to={link.to}
                exact={true}
            >
                <Dropdown.Item active={false} key={createUUID()}>{link.children}</Dropdown.Item>
            </LinkContainer>
        ))
    }

    return <Dropdown>
        <style>
            {
                `
                    .menu-toggle-dots.dropdown-toggle::after {
                        display: none;
                    }

                    .menu-toggle-dots.dropdown-toggle {
                        background-color: rgba(0,0,0,0) !important;
                        padding-left: 0.75rem;
                        padding-right: 0.75rem;
                        color: rgba(255,255,255,0.5) !important;
                    }

                    .menu-toggle-dots.dropdown-toggle:hover {
                        color: rgba(255,255,255,0.95) !important;
                        background: rgba(255,255,255,0.075) !important;
                    }

                    .menu-toggle-dots.dropdown-toggle:focus {
                        box-shadow: none !important;
                        background: rgba(255,255,255,0.075) !important;
                    }

                    .dropdown-dots .dropdown-item.active {
                        background: #fff;
                        font-weight: 500;
                        color: #000;
                    }
                `
            }
        </style>
        <Dropdown.Toggle
            className="menu-toggle-dots"
            variant={props.variant ? props.variant : "outline-light"} title={t('NavigationSecondaryDropdown.more-items')}>
            <FontAwesomeIcon icon={faEllipsisH} size="sm" />
        </Dropdown.Toggle>
        <Dropdown.Menu
            className="dropdown-dots"
            style={
                {
                    maxHeight: `calc(100vh - 44px - 1rem)`,
                    overflow: `auto`,
                }
            }
        >
            {linksFragment}
        </Dropdown.Menu>
    </Dropdown>
}

export default LinksSecondaryDropdown;
